/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import './ModalDetail.css';

const ModalDetail = React.forwardRef(({ children, modalOptions }, ref) => (
  <div className="simple-modal-container" ref={ref}>
    <h2 className="simple-modal-title">{modalOptions.title}</h2>
    <p className="simple-modal-description">{modalOptions.description}</p>
    <div className="simple-modal-wrapper-btn">
      {children || null}
    </div>
  </div>
));

ModalDetail.propTypes = {
  children: PropTypes.node,
  modalOptions: PropTypes.object.isRequired,
};

ModalDetail.defaultProps = {
  children: null,
};

export default ModalDetail;
